import React, { useEffect, useState } from 'react';
import { Badge, Result, Tabs } from 'antd';
import HarcirahKabuk from './kabuk';
import HarcirahRapor from './HarcirahRapor';
import OnayKutusu from './OnayKutusu';
import { PersonelSekmesi } from './seyahat';
import { useHarcirahApi } from './ortak';

/**
 * Yönetim ekranı (/harcirah/yonetim, 24.10.2026 ekran ayrımı). Onay Kutusu: her onaycı (amir, finans, yönetim) yalnız
 * kendi aşamasındaki seyahatleri görür. Rapor ve Personel: yalnız Harcırah r (yönetim); seyahat ayrıntısı salt okunur.
 * 30.10.2026: "Toplu Görünüm" — yalnız tam_panel (kullanıcı: "güncel hali sadece ben göreyim"); diğerleri rol ekranlarını
 * (Finans, Onaylarım, Rapor — ekranlar.jsx) kullanır.
 */
function YonetimSekmeleri({ roller }) {
  const api = useHarcirahApi();
  const onayApi = useHarcirahApi('/harcirah-onay');
  const [secenekler, setSecenekler] = useState(null);
  const [onayBekleyen, setOnayBekleyen] = useState(0);

  useEffect(() => {
    if (roller.rapor === 'tam') api.get('/secenekler').then(setSecenekler).catch(() => {});
    onayApi.get('').then((d) => setOnayBekleyen(d.bekleyen.length)).catch(() => {});
  }, [api, onayApi, roller.rapor]);

  const sekmeler = [
    { key: 'onay', label: <Badge count={onayBekleyen} size="small" offset={[8, -2]}>Onay Kutusu</Badge>,
      children: <OnayKutusu onSayi={setOnayBekleyen} /> },
    ...(roller.rapor === 'tam' ? [
      { key: 'rapor', label: 'Rapor', children: <HarcirahRapor /> },
      { key: 'personel', label: 'Personel', children: <PersonelSekmesi secenekler={secenekler} /> },
    ] : []),
  ];
  return <Tabs type="card" destroyOnHidden items={sekmeler} />;
}

export default function HarcirahYonetim() {
  return (
    <HarcirahKabuk baslik="Toplu Görünüm">
      {(roller) => (roller.tam_panel ? <YonetimSekmeleri roller={roller} />
        : <Result status="403" title="Bu ekran size kapalı" subTitle="İşlemleriniz için üstteki ekranları kullanın." />)}
    </HarcirahKabuk>
  );
}
